<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
      <v-spacer></v-spacer>
      <accumulate-nav-button></accumulate-nav-button>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>お支払い方法を選択</v-card-title>
      <v-card-subtitle>お支払い方法を選択してください。</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select
              :items="paymentMethods"
              placeholder="お支払い方法を選択してください"
              v-model="paymentMethod"
              outlined
              hide-details
            >
              <template slot="selection" slot-scope="data">
                <v-row>
                  &nbsp;&nbsp;
                  {{ data.item.text }}
                  &nbsp;
                  <div v-if="data.item.value == 'credit_card'" class="cardNumber-img" />
                </v-row>
              </template>
              <template slot="item" slot-scope="data">
                <v-row>
                  &nbsp;&nbsp;
                  {{ data.item.text }}
                  &nbsp;
                  <div v-if="data.item.value == 'credit_card'" class="cardNumber-img" />
                </v-row>
              </template>
            </v-select>
          </v-col>
        </v-row>

        <StripeElements
          v-if="paymentMethod == 'credit_card' && false"
          :stripe-key="stripePublishableKey"
          :instance-options="instanceOptions"
          :elements-options="elementsOptions"
          #default="{ elements }"
          ref="elms"
        >
          <!-- card, cardNumber, cardExpiry, cardCvc, postalCode, paymentRequestButton, iban, idealBank, p24Bank, auBankAccount, fpxBank, affirmMessage, afterpayClearpayMessage -->
          <!-- <StripeElement type="card" :elements="elements" :options="cardOptions" ref="card" /> -->
          <v-row>
            <v-col>
              <div class="cardNumber-wrapper">
                <StripeElement type="cardNumber" :elements="elements" :options="cardNumberOptions" ref="cardNumber" />
                <div class="cardNumber-img" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="cardExpiry-wrapper">
                <StripeElement type="cardExpiry" :elements="elements" :options="cardExpiryOptions" />
              </div>
            </v-col>
            <v-col>
              <div class="cardCvc-wrapper">
                <StripeElement type="cardCvc" :elements="elements" :options="cardCvcOptions" />
                <div class="cardCvc-img" />
              </div>
            </v-col>
          </v-row>
        </StripeElements>

        <v-row v-if="paymentMethod == 'bank_transfer'">
          <v-col>
            <div>
              お振込についてのご案内をさせて頂きます。<br /><br />
              お振込に関しましては、ご注文（単品購入日、もしくは、定期購入の更新日）から7日以内にお願い致します。お振込の確認が取れ次第、商品を発送いたします。尚、銀行振込時にかかる手数料はお客様にてご負担を頂いております。予めご了承ください。<br /><br />
              お振込先<br />
              金融機関: みずほ銀行 <br />
              支店: 青山支店<br />
              口座番号: 3208980<br />
              口座名義: 株式会社シープラス<br /><br />
              <a
                href=""
                @click="
                  handleSendPaymentInfo()
                  $event.preventDefault()
                "
              >
                お振込先情報をメールする
                <v-progress-circular
                  v-if="isSendingEmail"
                  indeterminate
                  color="primary"
                  :width="2"
                  :size="20"
                  class="ml-2"
                ></v-progress-circular>
              </a>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-footer fixed color="var(--bg-color)">
      <v-card-text>
        <v-row dense v-if="plan != Plan.ONE_TIME_PURCHASE">
          <v-col class="subtotal-label"> クーポンコード </v-col>
          <v-col class="subtotal-value">
            <span v-if="couponCode">
              {{ couponCode }}
              <v-btn class="skip-my-style" icon @click="clearCouponCode">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
            <v-btn v-else class="skip-my-style" small @click="enterCouponCode">クーポンを入力する</v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col class="subtotal-label"> 小計 </v-col>
          <v-col class="subtotal-value" v-if="isLoadingCouponCode">
            <v-progress-circular class="mr-5" indeterminate color="primary" :width="2" :size="20" />
          </v-col>
          <v-col class="subtotal-value" v-else>
            {{ subtotal }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-btn color="primary" :disabled="isProcessing || !paymentMethod" @click="handleNext">
              <v-progress-circular
                v-if="isProcessing"
                indeterminate
                color="primary"
                :width="2"
                :size="20"
              ></v-progress-circular>
              {{ isProcessing ? null : '購入する' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-footer>
  </v-container>
</template>

<script>
import { env } from '@/services/env'
import { createNamespacedHelpers } from 'vuex'
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import AccumulateNavButton from '@/components/buttons/AccumulateNavButton.vue'
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus'
import { PaymentMethod, Plan, userCollection } from '@shared/collections/user.collection'
import { createCheckoutSession, getCoupon, sendPaymentInfoEmail } from '@/services/functions'
import { isSubscriptionActive } from '@/helpers/subscription'
import { formatMoney } from '@/helpers/number'
import { STORAGE_KEY_COUPON_CODE } from './SelectPlan.vue'

const userStore = createNamespacedHelpers('user')

export default {
  components: {
    SeaPlusNavIcon,
    AccumulateNavButton,
    StripeElements,
    StripeElement
  },
  data: () => ({
    Plan,
    plan: null,
    paymentMethod: PaymentMethod.CREDIT_CARD,
    paymentMethods: PaymentMethod.all().map((v) => ({
      text: PaymentMethod.getLabel(v),
      value: v
    })),
    couponCode: null,
    coupon: null,
    isLoadingCouponCode: false,
    isProcessing: false,
    isSendingEmail: false,

    stripePublishableKey: env.stripePublishableKey,
    instanceOptions: {
      // https://stripe.com/docs/js/initializing#init_stripe_js-options
    },
    elementsOptions: {
      // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      locale: 'ja'
    },
    // https://stripe.com/docs/js/appendix/style
    cardNumberOptions: {
      style: {
        base: {
          fontSize: '18px',
          lineHeight: '56px'
        }
      }
    },
    cardExpiryOptions: {
      style: {
        base: {
          fontSize: '18px',
          lineHeight: '56px'
        }
      }
    },
    cardCvcOptions: {
      style: {
        base: {
          fontSize: '18px',
          lineHeight: '56px'
        }
      },
      placeholder: 'CVC'
    },
    instance: {},
    elements: {}
  }),
  computed: {
    ...userStore.mapState(['userId', 'user']),
    subtotal() {
      let tempSubtotal = this.plan ? Plan.getSubtotal(this.plan) : 0
      if (this.coupon && this.plan !== Plan.ONE_TIME_PURCHASE) {
        if (this.coupon.percent_off) {
          tempSubtotal = tempSubtotal * (1 - this.coupon.percent_off / 100)
        } else if (this.coupon.amount_off) {
          tempSubtotal -= this.coupon.amount_off
        }
      }
      return formatMoney(tempSubtotal, '円')
    }
  },
  methods: {
    async handleNext() {
      const { paymentMethod } = this
      if (paymentMethod == PaymentMethod.CREDIT_CARD) {
        await this.createCheckoutSession()

        // this.isProcessing = true
        // await this.$refs.elms.instance
        //   .createPaymentMethod({
        //     card: this.$refs.cardNumber.stripeElement,
        //     type: 'card'
        //   })
        //   .then((result) => {
        //     console.log({ result })
        //     if (result.error) {
        //       alertError(result.error)
        //     } else if (result.paymentMethod) {
        //       this.$router.push('/register-shipping-info')
        //     }
        //   })
        //   .catch((error) => {
        //     console.log({ error })
        //     alertError(error)
        //   })
        // this.isProcessing = false
      } else if (paymentMethod == PaymentMethod.BANK_TRANSFER) {
        this.isProcessing = true
        await userCollection.update(this.user.id, {
          plan: this.plan,
          paymentMethod: this.paymentMethod
        })
        this.isProcessing = false
        this.$router.push('/register-shipping-info')
      }
    },
    async createCheckoutSession() {
      this.isProcessing = true
      await userCollection.update(this.user.id, {
        plan: this.plan,
        paymentMethod: this.paymentMethod
      })
      const {
        data: { checkoutSession }
      } = await createCheckoutSession({
        plan: this.plan,
        couponCode: this.couponCode,
        successUrl: `${window.location.origin}/checkout/success`,
        cancelUrl: `${window.location.origin}/select-payment-method?plan=${this.plan}`
      })
      this.isProcessing = false
      if (checkoutSession && checkoutSession.url) {
        window.location.href = checkoutSession.url
      }
    },
    checkStripeSubscriptionStatus() {
      const { user } = this
      if (user && isSubscriptionActive(user)) {
        this.$router.replace('/')
      }
    },
    async handleSendPaymentInfo() {
      if (this.isSendingEmail) {
        return
      }

      this.isSendingEmail = true
      const {
        data: { success }
      } = await sendPaymentInfoEmail()
      if (success) {
        alert('お振込先情報をメールしました。\n「購入する」ボタンをクリックして、購入を完了して下さい。')
      }
      this.isSendingEmail = false
    },
    enterCouponCode() {
      const newCouponCode = prompt('クーポンコードをご入力してください')
      this.couponCode = newCouponCode
      if (this.couponCode) {
        localStorage.setItem(STORAGE_KEY_COUPON_CODE, this.couponCode)
      }
    },
    clearCouponCode() {
      this.couponCode = null
      this.coupon = null
      localStorage.removeItem(STORAGE_KEY_COUPON_CODE)
    }
  },
  watch: {
    user() {
      this.checkStripeSubscriptionStatus()
    },
    async couponCode() {
      if (this.couponCode) {
        this.isLoadingCouponCode = true
        const { data } = await getCoupon({ couponCode: this.couponCode })
        this.coupon = data.coupon
        this.isLoadingCouponCode = false
        console.log({ coupon: this.coupon })
        if (!data.coupon) {
          alert('クーポンコードが正しくありません。')
          this.clearCouponCode()
        }
      } else {
        this.coupon = null
        localStorage.removeItem(STORAGE_KEY_COUPON_CODE)
      }
    }
  },
  async mounted() {
    this.checkStripeSubscriptionStatus()
    this.plan = this.$route.query.plan
    this.couponCode = localStorage.getItem(STORAGE_KEY_COUPON_CODE)

    if (!this.plan) {
      this.$router.replace('/select-plan')
    }
  }
}
</script>

<style scoped>
.subtotal-label {
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 1.2em;
}
.subtotal-value {
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 1.2em;
  text-align: right;
}

.cardNumber-wrapper,
.cardExpiry-wrapper,
.cardCvc-wrapper {
  padding: 0 12px;
  min-height: 56px;
  border: 2px solid;
}

.cardNumber-wrapper {
  margin-top: 12px;
}

.cardNumber-wrapper,
.cardCvc-wrapper {
  display: flex;
  flex-direction: row;
}

.cardNumber-wrapper > div:first-child,
.cardCvc-wrapper > div:first-child {
  flex: 1;
}

.cardNumber-img {
  width: 90px;
  background-image: url('/public/images/ic_credit_card@3x.png');
  background-position: center;
  background-size: contain;
}
.cardCvc-img {
  width: 24px;
  background-image: url('/public/images/ic_cvc@3x.png');
  background-position: center;
  background-size: contain;
}
</style>
